// 어느 지인에듀 사이트로 로그인하나: "english" | "math"(2026-10-06).
// 수학 사이트의 '온라인 출제' 버튼은 /?site=math 로 들어온다. 그 값을 기억했다가 로그인 주소를 받을 때 서버에 넘긴다.
// 화면은 하나를 같이 쓰고, 수학 계정이면 영어 문제지 메뉴만 숨긴다(pages/HomePage.jsx). 서버: api/user/sites.py
const LOGIN_SITE_KEY = "login_site";
// 이번 방문에 주소로 사이트를 고르고 들어왔는가. 이미 다른 사이트 계정으로 로그인해 있으면 다시 로그인시킨다
const REQUESTED_SITE_KEY = "requested_site";
const SITE_LIST = ["english", "math"];

const safeGet = (storage, key) => {
  try {
    return storage.getItem(key);
  } catch (error) {
    return null;
  }
};

const safeSet = (storage, key, value) => {
  try {
    if (value === null) storage.removeItem(key);
    else storage.setItem(key, value);
  } catch (error) {
    // 저장소를 못 쓰는 브라우저면 영어로 로그인한다
  }
};

// 영어 지인에듀의 '온라인 출제' 버튼은 ?site 없이 첫 화면(/)으로 들어온다. 그래서 주소만 보면 한 번
// 수학으로 들어온 브라우저는 계속 수학으로 로그인되어 영어로 돌아가지 못했다(2026-10-16).
// 지인에듀는 referrer-policy 가 same-origin 이라 어디서 눌러 왔는지(referrer)가 오지 않는다.
// 그래서 바깥에서 첫 화면이나 로그인 화면으로 들어온 것을 영어로 본다. 수학 버튼은 ?site=math 를 달고 온다.
// 우리 화면 안에서 옮겨 간 것(로그아웃, 토큰 만료로 /login 이동)은 referrer 가 우리 주소라 건드리지 않는다.
const ENTRY_PATH_LIST = ["/", "/login"];

// 홈 화면에 설치한 앱으로 열렸는가. 설치 앱은 referrer 없이 시작 주소로 열려서 바깥에서 들어온 것처럼 보인다.
// 영어로 되돌리면 수학 앱이 열 때마다 영어 로그인으로 간다(2026-11-02). 그래서 마지막에 쓴 사이트를 그대로 둔다.
const isInstalledApp = () => {
  try {
    return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
  } catch (error) {
    return false;
  }
};

const siteFromEntry = () => {
  if (!ENTRY_PATH_LIST.includes(window.location.pathname)) return null;
  if (isInstalledApp()) return null;
  let referrerOrigin = "";
  try {
    referrerOrigin = document.referrer ? new URL(document.referrer).origin : "";
  } catch (error) {
    referrerOrigin = "";
  }
  if (referrerOrigin === window.location.origin) return null;
  return "english";
};

export const rememberSiteFromUrl = () => {
  const urlSite = new URLSearchParams(window.location.search).get("site");
  const site = SITE_LIST.includes(urlSite) ? urlSite : siteFromEntry();
  if (!SITE_LIST.includes(site)) return;
  safeSet(localStorage, LOGIN_SITE_KEY, site);
  safeSet(sessionStorage, REQUESTED_SITE_KEY, site);
};

export const getLoginSite = () => {
  const site = safeGet(localStorage, LOGIN_SITE_KEY);
  return SITE_LIST.includes(site) ? site : "english";
};

// 주소로 고른 사이트와 지금 로그인한 계정의 사이트가 다르면 그 사이트 이름을, 아니면 null
export const takeSiteMismatch = (userSite) => {
  const requested = safeGet(sessionStorage, REQUESTED_SITE_KEY);
  safeSet(sessionStorage, REQUESTED_SITE_KEY, null);
  if (!SITE_LIST.includes(requested)) return null;
  return requested !== (userSite || "english") ? requested : null;
};
